class ContactUs {

    constructor(model) {
        this.model = model;

        this.telInput = $("#PhoneNumber");
        this.initCountry = 'us';
        this.pattern = '';

        this.timeout = null;

        this.init = this.init.bind(this);
        this.setupListeners = this.setupListeners.bind(this);
    }

    updatePattern() {

        const thisInput = $(this);

        // Use updated placeholder to define formatting pattern
        const updatedPattern = thisInput.attr("placeholder").replace(new RegExp("[0-9]", "g"), "9").replace(/([9]\d{0,10})/g, '{{$1}}');

        // update formatter
        thisInput.formatter().resetPattern(updatedPattern);

        // clear telephone input to prevent validation errors
        thisInput.val("");

        // Remove Error from Input
        $("#PhoneNumberWrapper").removeClass("error");
        $("#PhoneNumberWrapper .help-block").hide();

    }

    initTelInput() {
        this.pattern = this.initCountry === 'us' ? '({{999}}) {{999}}-{{9999}}' : '{{9999999999999999999999}}';

        this.telInput.intlTelInput({
            initialCountry: this.initCountry,
            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@16.0.3/build/js/utils.js"
        });
    }

    initFormat() {
        // init format
        this.telInput.formatter({
            'pattern': this.pattern
        });
    }

    validatePhoneInput(ele) {
        const thisInput = $(ele);

        if ($.trim(thisInput.val())) {
            // if phone number is valid
            if (thisInput.intlTelInput("isValidNumber")) {

                // set error states
                if ($("#PhoneNumberWrapper").hasClass("error")) {
                    $("#PhoneNumberWrapper").removeClass("error");
                }

                $("#PhoneNumberWrapper .help-block").hide();
                thisInput.setCustomValidity('');

            } else {

                // set error states
                if (!$("#PhoneNumberWrapper").hasClass("error")) {
                    $("#PhoneNumberWrapper").addClass("error");
                }

                thisInput.setCustomValidity('Invalid Phone Number');
                $("#PhoneNumberWrapper .help-block").text("Invalid Phone Number").show();

            }

        } else {
            $("#PhoneNumberWrapper").addClass("error");
            $("#PhoneNumberWrapper .help-block").text("The Contact Phone Number field is required.").show();
        }

        this.checkFormValidity();

    }

    validateInput(ele) {

        const input = $(ele);
        const inputParent = input.parent();
        const inputHelpText = inputParent.find(".help-block");
        const inputLabelText = ele.previousElementSibling.innerText;

        if ($.trim(input.val())) {
            // set error states
            if (inputParent.hasClass("error")) {
                inputParent.removeClass("error");
            }

            inputHelpText.hide();

        } else {

            inputParent.addClass("error");
            inputHelpText.text(`The ${inputLabelText} field is required.`).show();

        }

        this.checkFormValidity();

    }

    checkFormValidity() {
        let isValid = true;

        let formInputs = [
            '#FirstName',
            '#LastName',
            '#Email',
            '#PhoneNumber',
            '#Message'
        ];

        $.each(formInputs, function(i,ele) {
            let fieldIsValid = $(ele).checkValidity();
            let fieldIsNotEmpty = $(ele).val() !== '';
            let isThisFieldValid = fieldIsValid && fieldIsNotEmpty;

            if (!isThisFieldValid) {
                isValid = false;
                return false;
            }

        });

        var response = 0;
        if (this.model.ReCaptchaSiteKey !== "") {
            response = grecaptcha.getResponse();
        }

        if (isValid && (this.model.ReCaptchaSiteKey === "" || response.length > 0)) {
            $("#submit").prop("disabled", null);
        } else {
            $("#submit").prop("disabled", true);
        }
    }

    setupListeners() {

        let self = this;

        let formInputs = '#FirstName, #LastName, #Email, #Message';

        // on keyup wait to validate
        $(formInputs).on('keydown', (e) => {
            clearTimeout(this.timeout);

            this.timeout = setTimeout(function () {
                self.validateInput(e.target);
            }, 300);
        });

        // on keyup wait to validate
        this.telInput.on('keyup', (e) => {
            clearTimeout(this.timeout);

            this.timeout = setTimeout(function () {
                self.validatePhoneInput(self.telInput);
            }, 300);
        });

        // on change to input or country code reset input
        this.telInput.on('countrychange', this.updatePattern);

    }

    init(data) {

        // Tell default jQuery validate to ignore the Phone Number field as it was causing display issues. We are validating with our custom code above.
        $('#ContactUs').validate().settings.ignore = "#PhoneNumber";

        this.initTelInput();

        this.initFormat();

        this.setupListeners();

        if (this.model.Username !== null) {
            $("#Username").attr("readonly", "readonly");
        }

        if (data.emailSent === "True") {
            $('#emailSentModal').appendTo('body').modal('show');
        }

        if (data.emailUnavailable === "True") {
            $('#emailUnavailableModal').appendTo('body').modal('show');
        }
    }

}